// Telkom's ext_ref: one per attempt, shared by /otp and /sub (Evina validates on it), max 35 chars.
export default function generateExtRef(prefix = 'TZA') {
  const time = Date.now().toString(36)
  const random = Math.random().toString(36).slice(2, 8)
  return `${prefix}-${time}-${random}`.slice(0, 35)
}
